<template>
<div>
  <v-tabs v-if='!isCompact' vertical dark show-arrows grow v-model='activeTab' >
    <v-tab
      v-for="(item, index) in items"
      :key="item.id" >
      <v-icon v-if='index===0' >home</v-icon>
      <span v-else >{{ item.title }}</span>
    </v-tab>
    <v-tabs-items
      v-model='activeTab' >
      <v-tab-item
        v-for="(item, index) in items"
      :key="item.id" >
        <component
          lazy
          v-if='item.component && activeTab === index'
          :is='item.component'
          v-bind='item.attrs'
          v-on='item.evnts || {}' >
        </component>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>

  <v-expansion-panel v-else v-model='activeTab' class='elevation-0' focusable  >
    <v-expansion-panel-content
      v-for="(item, index) in items"
      :key="item.id" >
      <template v-slot:header>
        <div class='subheading' >
          {{item.title}}</div>
      </template>
      <component
        lazy
        v-if='item.component && activeTab === index'
        :is='item.component'
        v-bind='item.attrs'
        v-on='item.evnts || {}' >
      </component>
    </v-expansion-panel-content>
  </v-expansion-panel>
</div>
</template>
<script>
export default {
  name: 'FlexibleComponentContainer',
  data () {
    return {
      activeTab: 0
    }
  },
  props: {
    items: { type: Array, default: () => { return [] } },
    isCompact: { type: Boolean, default: false }
  }
}
</script>



// WEBPACK FOOTER //
// FlexibleComponentContainer.vue?7e311fee